<template>
  <NuxtLink :to="props.link" :class="['btn', props.class || '']">
    <span class="btn__title">{{ props.text }}</span>
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  text: String,
  link: String,
  class: {
    type: String,
    default: "btn--primary-white",
  },
});
</script>
